// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text_value>p{margin:0}.text_form>.el-form-item>.el-form-item__label{width:100%!important}.text_form.el-form--inline{display:flex;flex-direction:row;justify-content:space-around;background-color:#fff}", ""]);
// Exports
module.exports = exports;
